// extracted by mini-css-extract-plugin
export default {"information":"styles_information__LQclg","informationItem":"styles_informationItem__6k4AU","header":"styles_header__M9Q15","actions":"styles_actions__Qy6fr"};